import {
    Field,
    FormikProps
} from 'formik';
import {
    FormikRadioCardGroup,
    PlatformFieldset
} from "@flexinet/ui-components";
import {
    ApplicationProductFormType,
    ApplicationProductStatus
} from "../types.ts";
import {ProductsAutocomplete} from "../../products/inputs/ProductsAutocomplete.tsx";


export const FormComponent = (props: FormikProps<ApplicationProductFormType>) => {

    const editing = typeof props.values.id !== 'undefined';

    return (
        <>
            <PlatformFieldset legend={'Application Product Details'}>

                <Field
                    name='productId'
                    label='Product'
                    description='Please select product'
                    component={ProductsAutocomplete}
                    disabled={editing}
                    withAsterisk
                    my={'xl'}
                />

            </PlatformFieldset>


            <PlatformFieldset legend={'Status'}>

                <Field
                    name='applicationProductStatus'
                    data={[{
                        label: ApplicationProductStatus.ACTIVE,
                        value: ApplicationProductStatus.ACTIVE
                    }, {
                        label: ApplicationProductStatus.INACTIVE,
                        value: ApplicationProductStatus.INACTIVE
                    }]}
                    component={FormikRadioCardGroup}
                    withAsterisk
                    my={'xl'}
                />

            </PlatformFieldset>
        </>
    );
};
